import React, { useState, useEffect } from 'react';

const Pagination = ({ total, pagination, handlePageChange, handleLimitChange }) => {
  const totalPages = Math.ceil(total / pagination.limit);
  const [inputPage, setInputPage] = useState(pagination.page);

  const onPageChange = (page) => {
    handlePageChange(page);
  };

  const handleInputChange = (e) => {
    if (e.target.value > totalPages) {
      setInputPage(totalPages);
    } else {
      setInputPage(e.target.value);
    }
  };

  const handleInputSubmit = (e) => {
    e.preventDefault();
    let page = parseInt(inputPage, 5) || 1;
    page = Math.min(page, totalPages);
    onPageChange(page);
  };

  useEffect(() => {
    setInputPage(pagination.page);
  }, [pagination.page]);

  const renderPaginationNumbers = () => {
    const currentPage = parseInt(pagination.page);
    const visiblePages = 2;

    const startPage = Math.max(1, parseInt(currentPage) - parseInt(visiblePages));
    const endPage = Math.min(parseInt(totalPages), parseInt(currentPage) + parseInt(visiblePages));

    return Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index).map((page) => (
      <button
        key={page}
        onClick={() => onPageChange(page)}
        className={`px-3 py-1 mx-1 rounded-md border ${
          page === currentPage
            ? 'theme-button  cursor-not-allowed'
            : 'bg-white text-gray-700 hover:bg-gray-200'
        }`}
        disabled={page === currentPage}
      >
        {page}
      </button>
    ));
  };

  const handleLimitSelection = (e) => {
    handleLimitChange(e);
  };

  return (
    // <div className="flex flex-wrap items-center justify-between gap-4 bg-white p-4 border rounded-md custom-lightest-border">
    <div className="flex flex-wrap items-center justify-between gap-4 bg-white p-4 vendor-sub-section-structure rounded-[5px] ">
      {/* Total Results */}
      <div className="text-gray-700">
        <span className="font-medium">Total Results:</span> {total}
      </div>

      {/* Pagination Controls */}
      {totalPages >= 1 && pagination.page <= totalPages ? (
        <div className="flex items-center">
          <button
            onClick={() => onPageChange(parseInt(pagination.page) - 1)}
            disabled={parseInt(pagination.page) === 1}
            className="px-3 py-1 mx-1 rounded-md border bg-white text-gray-700 hover:bg-gray-200 disabled:opacity-50"
          >
            {'<<'}
          </button>
          {renderPaginationNumbers()}
          <button
            onClick={() => onPageChange(parseInt(pagination.page) + 1)}
            disabled={parseInt(pagination.page) === totalPages || totalPages === 0}
            className="px-3 py-1 mx-1 rounded-md border bg-white text-gray-700 hover:bg-gray-200 disabled:opacity-50"
          >
            {'>>'}
          </button>
        </div>
      ) : (
        <div className="text-gray-500">No pages to display</div>
      )}

      {/* Go to Page */}
      <form onSubmit={handleInputSubmit} className="flex items-center space-x-2">
        <label htmlFor="pageInput" className="text-gray-700 font-medium">
          Page:
        </label>
        <input
          type="number"
          id="pageInput"
          value={inputPage}
          onChange={handleInputChange}
          min="1"
          className="w-16 px-2 py-1 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
        />
      </form>

      {/* Per Page */}
      <div className="flex items-center space-x-2">
        <label htmlFor="perPage" className="text-gray-700 font-medium">
          Per Page:
        </label>
        <select
          id="perPage"
          value={pagination.limit}
          onChange={handleLimitSelection}
          className="px-2 py-1 border rounded-md focus:outline-none focus:ring focus:ring-blue-300"
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
    </div>
  );
};

export default Pagination;
